











import { isMobileOnly } from 'mobile-device-detect'
import './KisweNotification.scss'
import { defineComponent } from '@vue/composition-api'
import useNotification from '@/compositions/notifications'


export default defineComponent({
  name: 'KisweNotification',
  props: {
    content: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup () {
    return {
      ...useNotification()
    }
  },

  computed: {
    isMobileOnly (): boolean {
      return isMobileOnly
    },
    paragraph (): string|null {
      if (this.content) return this.content
      if (this.notifications?.eventlist) return this.notifications?.eventlist.content
      return null
    }
  }
})
